// extracted by mini-css-extract-plugin
export default {"container":"Main_container__dAwAk","content":"Main_content__oXx2y","btnContainer":"Main_btnContainer__6NPH8"};